import React from 'react';
import {
  Checkbox,
  TextInput,
  DatePickerField,
} from '../../../layout/FormElement';

type workFormProps = {
  values: any;
  setFieldValue: Function;
  errors: any;
};

const ProjectForm = (props: workFormProps) => {
  const values = props.values;
  const setFieldValue = props.setFieldValue;
  return (
    <div className='grid grid-cols-2 gap-8 p-4 sm:p-8 bg-gray-50'>
      <div>
        <TextInput name='projectName' type='text' placeholder='Project Name' />
      </div>
      <div>
        <TextInput name='country' type='text' placeholder='Country' />
      </div>
      <div className='col-span-2'>
        <TextInput name='projectUrl' type='text' placeholder='Project Url' />
      </div>
      <div className='col-span-2'>
        <TextInput name='description' type='text' placeholder='Description' />
      </div>
      <div>
        <DatePickerField
          label='Start Date'
          name='startDate'
          value={values.startDate}
          onChange={setFieldValue}
        />
        <div className='text-sm text-red-500'>{props.errors.startDate}</div>
      </div>
      <div>
        <DatePickerField
          label='End Date'
          name='endDate'
          value={values.endDate}
          onChange={setFieldValue}
        />
        <div className='text-sm text-red-500'>{props.errors.endDate}</div>
      </div>
      <div className='col-span-2'>
        <Checkbox name='currentlyWorkingHere'>
          I am currently working on this Project
        </Checkbox>
      </div>
    </div>
  );
};

export default ProjectForm;
